import { canProceedToRiskQuestionnaire } from 'quick-quote/product-investment/journey-control-selectors'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { acceptForeignInvestment, acceptHigherRiskInvestment } from './actions'
import RiskQuestionnaire from './components'
import {
  getAllowForeignInvestment,
  getAllowHigherRiskInvestment,
  hasValidEntryComponent,
  isEvaluated,
} from './selectors'

const mapStateToProps = (state) => {
  return {
    isEvaluated: isEvaluated(state),
    hasValidEntryComponent: hasValidEntryComponent(state),
    canProceedToRiskQuestionnaire: canProceedToRiskQuestionnaire(state),
    allowHigherRiskInvestment: getAllowHigherRiskInvestment(state),
    allowForeignInvestment: getAllowForeignInvestment(state),
  }
}

const mapDispatchToProps = (dispatch) => ({
  acceptHigherRiskInvestment: bindActionCreators(acceptHigherRiskInvestment, dispatch),
  acceptForeignInvestment: bindActionCreators(acceptForeignInvestment, dispatch),
})

const RiskContainer = connect(mapStateToProps, mapDispatchToProps)(RiskQuestionnaire)
export default RiskContainer
